const riot = require('riot');

riot.tag2('page-projects-single-edit', '<div class="f"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <div class="w-full f fclm bg-pale_gray"> <div data-is="module-page-header" title="プロジェクト{isNew ? \'新規作成\' : \'設定\'}"></div> <div class="f fclm px40 py36"> <form class="f fclm bg-white rounded-8 elevation-default-low mb32" onsubmit="{onSubmit}"> <div class="section-padding"> <label class="block"> <div class="ts-hxs mb8">プロジェクト名</div> </label> <input class="input w500" ref="project" type="text" required placeholder="プロジェクト名を入力" riot-value="{project ? project.name : &quot;&quot;}" oninput="{dataChange}"> </div> <div data-is="module-section-footer" buttons="{buttons}"></div> </form> <div class="f fclm rounded-8 elevation-default-low bg-white" if="{!isNew}"> <div class="pt32 px32 pb20"> <div class="mb8" data-is="module-section-header" title="APIキー"></div> <div class="ts-pxs text-gray_60 mb20">常時キャンペーンにRepro Incentiveを利用したい場合など、Repro Incentive APIを呼び出すことで、ユーザーに報酬を受け渡すことができます。<br>APIキーはプロジェクト内で複数発行できます。</div> <button class="button" onclick="{onOpenModalPostApiKey}">APIキーを発行する</button> </div> <div class="f fclm"> <div class="max-height-500" data-is="module-table" schemas="{tableSchemas}" items="{projectApiKeys}" scroll-type="y"></div> <div class="f fr mta mr32"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div> </div> </div>', 'page-projects-single-edit,[data-is="page-projects-single-edit"]{display:block}', '', function(opts) {
    this.buttons = [
      {
        type: 'submit',
        text: '保存',
        class: 'outline',
      },
    ];

    this.limit = 50;

    this.tableSchemas = [
      {
        id: 'api_key',
        label: 'APIキー',
        class: 'flex-fixed w284',
        getText: (v, item) => item.visible ? v : '**********************************',
      },
      {
        id: 'visible_btn',
        component: 'material-icon-visibility-buttons',
        class: 'flex-fixed w52',
        onclick: (item, e) => {
          this.onAPIKeyVisibilityClicked(item, e);
        },
      },
      {
        id: 'name',
        label: '名前',
        class: 'w0 min-width-220 flex-auto',
      },
      {
        id: 'created_at',
        label: '生成日',
        class: 'w220 flex-fixed',
        getText: (v) => dayjs(v).format('YYYY-MM-DD'),
      },
      {
        id: 'menu',
        component: 'material-icon-button',
        text: 'more_vert',
        align: 'center',
        class: 'flex-fixed w52',
        onclick: (item, e) => {
          this.openMenuApiKey(item, e);
        },
      },
    ];

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;

      if (!app.utils.permission.has('project_admin', { company_id: req.params.company_id, project_id: req.params.project_id})) {
        throw { status: 403 };
      }

      var companyId = req.params.company_id;
      var project_id = req.params.project_id;

      var isNew = project_id === 'new';
      if (!isNew) {
        var api = app.api.child(`companies/${companyId}/projects/${project_id}/project_api_keys`);
        var promises = [
          app.api.child(`companies/${companyId}/projects/${project_id}`).get({}),
          api.get({limit: this.limit, offset: 0}),
        ];
        var [{ project }, { project_api_keys, pagination }] = await Promise.all(promises);

        var projectApiKeys = this.convertApiKeysForUI(project_api_keys);
      }

      return {
        isNew,
        companyId,
        project,
        projectApiKeys,
        pagination,
        api,
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title('プロジェクト設定', this),
      };
    };

    this.on('beforeunload', async (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.on('show', () => {
      this.isChange = false;
    });

    this.on('hide', () => {
      this.reset();
    });

    this.onSubmit = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      var query = {
        name: this.refs.project.value,
      };
      try {

        if (this.isNew) {
          var { project } = await app.api.child(`companies/${this.companyId}/projects`).post(query);
        }

        else {
          var { project } = await app.api.child(`companies/${this.project.company.id}/projects/${this.project.id}`).put(query);
          spat.modal.alert('更新しました');
        }
        this.refs.project.value = '';
        this.update();
        spat.router.push(`/app/companies/${project.company.id}/projects/${project.id}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.reset = () => {
      this.project = {};
      this.update();
    };

    this.dataChange = () => {
      this.isChange = true;
    };

    this.postApiKey = async (value) => {
      var indicator = spat.modal.indicator();
      try {
        await this.api.post({ name: value });
        var { project_api_keys, pagination } = await this.api.get({limit: this.limit, offset: 0});
        this.projectApiKeys = this.convertApiKeysForUI(project_api_keys);
        this.pagination = pagination;
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.putApiKey = async (value, item) => {
      var indicator = spat.modal.indicator();
      try {
        await this.api.child(item.id).put({ name: value });
        var { project_api_keys, pagination } = await this.api.get({limit: this.limit, offset: 0});
        this.projectApiKeys = this.convertApiKeysForUI(project_api_keys);
        this.pagination = pagination;
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onOpenModalPostApiKey = async () => {
      var buttons = [
        {
          type: 'button',
          text: 'キャンセル',
          class: 'text',
          onclick: () => modal.close(),
        },
        {
          type: 'submit',
          text: '発行する',
          class: 'outline',
        },
      ];
      var modal = await app.utils.openModalInput(
        {
          title: 'APIキー発行',
          input_lable: 'APIキー名',
          required: true,
          buttons,
          submit: (v) => this.postApiKey(v),
        }
      );
    };

    this.openModalPutApiKey = async (item) => {
      var buttons = [
        {
          type: 'button',
          text: 'キャンセル',
          class: 'text',
          onclick: () => modal.close(),
        },
        {
          type: 'submit',
          text: '保存',
          class: 'outline',
        },
      ];

      var modal = await app.utils.openModalInput(
        {
          title: '名前の編集',
          input_lable: 'APIキー名',
          required: true,
          buttons,
          value: item.name,
          submit: (v) => this.putApiKey(v, item),
        },
      );
    };

    this.onAPIKeyVisibilityClicked = (item, e) => {
      e.preventDefault();
      e.stopPropagation();

      item.visible = !item.visible;
      this.update();
    };

    this.openMenuApiKey = (item, e) => {
      e.preventDefault();
      e.stopPropagation();

      var options = [
        {
          icon: "pencil",
          label: "名前を編集",
          action: () => {
            popup.close();
            this.openModalPutApiKey(item);
          },
        },
        {
          icon: "logout",
          label: "APIキーをコピー",
          action: () => {
            popup.close();
            app.utils.copyToClipBoard(item.api_key);
            spat.toast.message('コピーしました');
          },
        },
        {
          icon: "trash",
          label: "削除",
          alert: true,
          action: () => {
            popup.close();
            this.deleteApiKey(item);
          },
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.deleteApiKey = async (item) => {
      var result = await app.utils.openModalDialog(
        {
          title: 'APIキーの削除',
          text: '本当にAPIキーを削除しますか？今後このAPIキーを利用した配布は行うことができなくなります。この操作は取り消すことができません。',
          danger: true,
          positive: '削除',
          size: 'medium',
        }
      );
      if (!result) return;

      var indicator = spat.modal.indicator();
      try {
        await this.api.child(item.id).del({});

        var { project_api_keys, pagination } = await this.api.get({limit: this.limit, offset: 0});
        this.projectApiKeys = this.convertApiKeysForUI(project_api_keys);
        this.pagination = pagination;
        this.update();
        spat.modal.alert('削除しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.convertApiKeysForUI = (apiKeys) => {
      if (!apiKeys) return [];
      return apiKeys.map(p => ({ ...p, visible: false }));
    };
});